import { cellNotFilter, emptyCellOneLevel } from "@/shared";
import { SingleButton } from "@/shared/components/ui";
import CustomCantidadInput from "@/shared/components/ui/CustomCantidadInput";
import CustomPrecioInput from "@/shared/components/ui/CustomPrecioInputProps";
import { MaterialTransferido, TreeNode } from "@/shared/interfaces"
import { Gastos } from "@/shared/interfaces/erp/inventario";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { MRT_ColumnDef } from "material-react-table"
import { useMemo, useState } from "react"
import { toast } from "react-toastify";
import PaymentIcon from '@mui/icons-material/Payment';
import { IconButton, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useGastos } from "@/store/erp/gastos/useGastos";
import { Costos } from '@/shared/interfaces/erp/activos/costo-activo.interface';
import { FacturaOrdenCompraGasto } from "@/shared/interfaces/erp/factura_compra_gasto/factura-compra-gasto.interface";

//const returnUrlFatcura = ROUTER_PATHS.contabilidad.registroFacturaNav
export default function useTableColumnsRegistroFacturas() {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarGasto = useGastos(s => s.handleEliminarGasto)
  const handleEliminarProducto = useCargarSeriesProductos(s => s.handleEliminarProducto)



  const [isOpenModal2, setOpenModal2] = useState(false)
  const [details, setDetails] = useState<TreeNode[]>([])

  const normalizarIva = (iva: string | number | undefined): number => {
    if (!iva) return 0;

    if (typeof iva === "number") return iva; // ya normalizado

    if (typeof iva === "string") {
      const clean = iva.trim();

      // 1) Caso: viene en porcentaje (ej: "15%", "15 %", "IVA 15%")
      if (clean.includes("%")) {
        const num = Number(clean.replace(/[^0-9.,]/g, "").replace(",", "."));
        return isNaN(num) ? 0 : num / 100;
      }

      // 2) Caso: viene como decimal en string (ej: "0.15" o "0,15")
      const numeric = Number(clean.replace(",", "."));
      return isNaN(numeric) ? 0 : numeric;
    }

    return 0;
  };
  const normalizaICE = (ice: string | number | undefined): number => {
    if (!ice) return 0
    if (typeof ice === "number") return ice
    if (typeof ice === "string") {
      const clean = ice.trim();

      // 1) Caso: viene en porcentaje (ej: "15%", "15 %", "IVA 15%")
      if (clean.includes("%")) {
        const num = Number(clean.replace(/[^0-9.,]/g, "").replace(",", "."));
        return isNaN(num) ? 0 : num / 100;
      }

      // 2) Caso: viene como decimal en string (ej: "0.15" o "0,15")
      const numeric = Number(clean.replace(",", "."));
      return isNaN(numeric) ? 0 : numeric;
    }

    return 0
  }


  const updateRowProduct = (id: string, updatedRow: MaterialTransferido) => {
    const cantidad = Number(updatedRow.cantidad || 0);
    //console.log('row cantidad', typeof cantidad)
    const precio = Number(updatedRow.precio_compra || 0);
    const descuento = Number(updatedRow.descuento || 0);
    const iva = normalizarIva(updatedRow.iva_porcentaje)
    const ice = normalizaICE(updatedRow.ice)
    //const iva = Number(updatedRow.iva_porcentaje || 0)
    console.log('iva_prod', iva)

    //operation
    const subtotal_descuento = cantidad * precio - descuento;
    const iva_producto = subtotal_descuento * iva
    const ice_producto = subtotal_descuento * ice
    const total_producto = subtotal_descuento + iva_producto + ice_producto

    //
    const newRow: MaterialTransferido = {
      ...updatedRow,
      subtotal_descuento: subtotal_descuento.toFixed(2),
      iva_producto: iva_producto.toFixed(2),
      ice_producto: ice_producto.toFixed(2),
      total_producto: total_producto.toFixed(2)

    }
    handleActualizarProducto(id, newRow)

  }

  const columns = useMemo<MRT_ColumnDef<FacturaOrdenCompraGasto>[]>(
    () => [
      {
        accessorKey: 'factura_data.codigo',
        header: 'Codigo'
      },
      {
        accessorKey: "proveedor_data.identificacion",
        header: 'Identificación Comprador'
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_emision",
        header: "fecha de emision",
      },

      {
        ...cellNotFilter,
        accessorKey: 'factura_data.total_sin_impuestos',
        header: 'Total sin Impuesto'
      },
      {
        ...cellNotFilter,
        accessorKey: 'factura_data.importe_total',
        header: 'Importe Total'
      },

    ], []
  )

  const infoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'accion',
        header: 'Accion',
        size: 80,
        Cell: ({ row }) => {
          return (
            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  handleEliminarProducto(row.original.id!)
                }}
              >
                <Delete />
              </IconButton>

            </Tooltip>
          )
        }
      },

      {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 60
      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Producto'
      },
      {
        accessorKey: 'cantidad',
        header: 'Cantidad',
        size: 120,
        Cell: ({ row }) => (
          <CustomCantidadInput<MaterialTransferido>
            value={row.original.cantidad}
            handleValue={value => {

              updateRowProduct(row.original.id, {
                ...row.original,
                cantidad: value
              })


            }}
            row={row}
          />
        )
      },
      {
        accessorKey: 'precio_compra',
        header: 'Valor Unitario',
        size: 80,
        Cell: ({ row }) => (
          <CustomPrecioInput<MaterialTransferido>
            value={row.original.precio_compra!}
            handleValue={(value) => {

              updateRowProduct(row.original.id, {
                ...row.original,
                precio_compra: value
              })
            }}
            row={row}
          />
        )
      },
      {
        accessorKey: 'descuento',
        header: 'Descuento',
        size: 60,
        Cell: ({ row }) => (
          <CustomPrecioInput<MaterialTransferido>
            value={row.original.descuento!}
            handleValue={value => {
              const subtotal = Number(row.original.cantidad) * Number(row.original.precio_compra)
              if (Number(value) > subtotal) {
                toast.error(`El descuento (${value}) no puede ser mayor que el subtotal (${subtotal}).`)

                updateRowProduct(row.original.id, {
                  ...row.original,
                  descuento: subtotal.toString()
                })
                return
              }
              updateRowProduct(row.original.id, {
                ...row.original,
                descuento: value
              })

            }}
            row={row}
          />
        )
      },
      {
        accessorKey: 'subtotal_descuento',
        header: 'subTotal con descuento'
      },
      {
        accessorKey: 'iva_producto',
        header: 'Iva',
        size: 80
      },
      {
        accessorKey: 'ice_producto',
        header: 'ice',
        size: 40,
        Cell: ({ row }) => row.original.ice_producto || 'N/A'
      },
      {
        accessorKey: 'total_producto',
        header: 'Total Con Iva'
      }
    ], [])
  const columnsInfoGasto = useMemo<MRT_ColumnDef<Gastos>[]>(
    () => [
      {
        accessorKey: 'accion',
        header: 'Accion',
        size: 80,
        Cell: ({ row }) => {
          return (
            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  handleEliminarGasto(row.original.id_gasto!)
                }}
              >
                <Delete />
              </IconButton>

            </Tooltip>
          )
        }
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre'
      },
      {
        accessorKey: 'cuentas_contables',
        header: 'Cuentas',
        size: 100,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="ver"
                variant="text"
                color={"info"}
                onClick={() => {
                  setDetails(JSON.parse(row.original.cuentas_contables))
                  setOpenModal2(true)
                }}
                startIcon={<PaymentIcon />}
              />
            </>
          )
        }
      },
      {
        accessorKey: 'subtotal_sin_iva',
        header: 'SubTotal sin Iva'

      },
      {
        accessorKey: 'subtotal_con_iva',
        header: 'SubTotal con Iva'
      },

      {
        accessorKey: 'valorICE',
        header: 'ICE',
        size: 80
      },
      {
        accessorKey: 'total',
        header: 'Total',
        size: 80
      }
    ], [])
  const columnsGastos = useMemo<MRT_ColumnDef<Gastos>[]>(
    () => [
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 270,
        Cell: ({ row }) => emptyCellOneLevel(row, 'nombre'),
      },
      {
        accessorKey: 'costo',
        header: 'Costo',
        size: 200,
        Cell: ({ row }) => emptyCellOneLevel(row, 'costo'),
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        size: 200,
        Cell: ({ row }) => emptyCellOneLevel(row, 'descripcion'),
      },
      {
        accessorKey: 'iva',
        header: 'IVA',
        size: 200,
        Cell: ({ row }) => emptyCellOneLevel(row, 'iva'),
      },
      {
        accessorKey: 'ice',
        header: 'ICE',
        size: 200,
        Cell: ({ row }) => emptyCellOneLevel(row, 'iva'),
      },


    ], []
  )
  const columnsCosto = useMemo<MRT_ColumnDef<Costos>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'codigo'
    },
    {
      accessorKey: 'nombre',
      header: 'nombre'
    },
    {
      accessorKey: 'descripcion',
      header: 'descripcion'
    },
    {
      accessorKey: 'costo',
      header: 'costo'
    },
    {
      accessorKey: 'mano_obra_directa',
      header: 'mano de obra directa'
    },
    {
      accessorKey: 'mano_obra_indirecta',
      header: 'mano de obra indirecta'
    },
    {
      accessorKey: 'cif',
      header: 'cif'
    }
  ], [])
  const columnsCuentasContable = useMemo<MRT_ColumnDef<TreeNode>[]>(() => [
    {
      accessorKey: 'id',
      header: 'Numero Cuenta'
    },
    {
      accessorKey: 'name',
      header: 'Nombre Cuenta'
    }

  ], [])
  return {
    columns,
    infoProducto,
    columnsInfoGasto,
    columnsGastos,
    columnsCosto,
    columnsCuentasContable,
    details,
    isOpenModal2,
    setOpenModal2
  }

}